import { render, staticRenderFns } from "./projectsReportPage.vue?vue&type=template&id=766ede9d&"
import script from "./projectsReportPage.vue?vue&type=script&lang=js&"
export * from "./projectsReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('766ede9d')) {
      api.createRecord('766ede9d', component.options)
    } else {
      api.reload('766ede9d', component.options)
    }
    module.hot.accept("./projectsReportPage.vue?vue&type=template&id=766ede9d&", function () {
      api.rerender('766ede9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/reports/include/projectsReportPage.vue"
export default component.exports